export default {"src":"/_next/static/media/StarS color.8d0f9630.svg","height":86,"width":86,"blurWidth":0,"blurHeight":0};